import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { getDb } from './firebase';

export interface District {
  id: string;
  name: string;
}

export interface County {
  id: string;
  name: string;
  districtId: string;
}

export interface Parish {
  id: string;
  name: string;
  countyId: string;
}

export async function getDistricts(): Promise<District[]> {
  const q = query(collection(getDb(), 'locations_districts'), orderBy('name'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, name: doc.data().name as string }));
}

export async function getAllCounties(): Promise<County[]> {
  const q = query(collection(getDb(), 'locations_counties'), orderBy('name'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    name: doc.data().name as string,
    districtId: doc.data().districtId as string,
  }));
}

export async function getCountiesByDistrict(districtId: string): Promise<County[]> {
  const q = query(
    collection(getDb(), 'locations_counties'),
    where('districtId', '==', districtId),
    orderBy('name')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    name: doc.data().name as string,
    districtId: doc.data().districtId as string,
  }));
}

export async function getParishesByCounty(countyId: string): Promise<Parish[]> {
  const q = query(
    collection(getDb(), 'locations_parishes'),
    where('countyId', '==', countyId),
    orderBy('name')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    name: doc.data().name as string,
    countyId: doc.data().countyId as string,
  }));
}
